import { jsx as t } from "react/jsx-runtime";
import { $ as n } from "./utils-CTvPli9r.js";
import { forwardRef as s } from "react";
const d = s(({ className: r, type: e, ...o }, i) => /* @__PURE__ */ t(
  "input",
  {
    type: e,
    className: n(
      "focus-visible:outline-0 ring-ring/80 ring-1 ring-inset focus:ring-ring focus:ring-2 focus:ring-inset flex h-9 w-full rounded-md border-0 border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
      r
    ),
    ref: i,
    ...o
  }
));
d.displayName = "Input";
export {
  d as Input
};
//# sourceMappingURL=input.js.map
